export const APP_VERSION = __APP_VERSION__ // defined in vite.config.ts

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as
  | string
  | undefined
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined

export const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY as string | undefined
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST as string | undefined
